// DS2.5.2
import React from 'react';
import c from 'classnames';
import {
  ThemeOverride,
  ThemeOptions,
} from '@wix/da-react-context/pkg/ThemeContext';
import IconButton, { Props as IconButtonProps } from '..';
import s from './IconButtonWithBackground.scss';

export type Props = IconButtonProps;

const IconButtonWithBackground: React.FC<Props> = ({
  className,
  variant = 'main',
  ...props
}) => {
  return (
    <div className={c(s['root'], className)}>
      <ThemeOverride theme={ThemeOptions.DARK}>
        <IconButton variant={variant} {...props} />
      </ThemeOverride>
    </div>
  );
};
IconButtonWithBackground.displayName = 'IconButtonWithBackground';

export default IconButtonWithBackground;
